import { RefObject, useEffect, useState } from 'react'

const useScrollable = (ref: RefObject<HTMLElement | null>) => {
  const [scrollableLeft, setScrollableLeft] = useState(false)
  const [scrollableRight, setScrollableRight] = useState(false)

  const handlescroll = (target: HTMLElement) => {
    setScrollableLeft(target.scrollLeft > 10)
    setScrollableRight(
      target.scrollLeft < target.scrollWidth - target.clientWidth - 10
    )
  }

  useEffect(() => {
    const element = ref.current
    if (!element) return

    const onScroll = (event: Event) => {
      const target = event.target as HTMLElement
      handlescroll(target)
    }

    handlescroll(element)

    element.addEventListener('scroll', onScroll)
    return () => {
      element.removeEventListener('scroll', onScroll)
    }
  }, [ref])

  const scrollLeft = () => {
    ref.current?.scrollTo({
      left: ref.current?.scrollLeft - 150,
      behavior: 'smooth',
    })
  }

  const scrollRight = () => {
    ref.current?.scrollTo({
      left: ref.current?.scrollLeft + 150,
      behavior: 'smooth',
    })
  }

  return {
    scrollableLeft,
    scrollableRight,
    scrollLeft,
    scrollRight,
  }
}

export default useScrollable
